export default "__VITE_ASSET__BetI1sfo__"